
<div class="value-logo">
  <img :src="Logo" class="light-only" />
  <img :src="LogoWhite" class="dark-only" />
</div>
